/**
 * @format
 * @flow
 */
// ルートパス
export const ROOT_PATH = '/';

// Auth関連
// 新規登録ページ
export const SIGN_UP_PATH = '/signup';
// パスワード登録ページ
export const PASSWORD_REGISTRATION_PATH = '/passwordregistration';
// ログインページ
export const SIGN_IN_PATH = '/login';
// パスワードリセット
export const PASSWORD_RESET_PATH = '/password-reset';
// パスワードリセット後認証
export const PASSWORD_RE_CONFIRM_PATH = '/password-re-confirm';

// トップページ
export const TOP_PATH = '/top';

// タスク関連
// 新規作成
export const TASK_NEW_PATH = '/tasks/register';
export const TASK_DUPLICATE_PATH = '/tasks/:task_id/duplicate';
export const TEMPLATE_PATH = '/template';
export const TEMPLATE_CREATE_PATH = '/template/new';
export const TEMPLATE_EDIT_PATH = '/template/edit/:id';

// プレビュー
export const TASK_PREVIEW_PATH = '/tasks/register/preview';
// 一覧
export const TASK_INDEX_PATH = '/tasks';
export const TASK_OLD_INDEX_PATH = '/tasks/old';
export const TASK_SHOW_PATH = '/task/:task_id';
export const TASK_EDIT_PATH = '/task/:task_id/edit';

// 外部リンク
export const ABOUT_TASKELL_URL = 'https://taskell.jp/company/';
export const PRIVACY_POLICY_URL = 'https://taskell.jp/policy/';

// 問い合わせ
export const SETTING_INDEX_PATH = '/setting';
export const SETTING_EDIT_PATH = '/setting/edit';

// 問い合わせ
export const CONTACT_PATH = '/contacts';

// 支払い状況
export const PAYMENT_PATH = '/payments';
export const PAYMENT_PDF_PATH = '/payments/pdf/:invoiceId/:year/:month/:dueDate';
export const PAYMENT_SHOW_PATH = '/payments/:year/:month';

// CREATE PDF
export const RESUME_PARTICIPANT_PATH = '/task/resumeparticipant/:taskrews_id';

// Cteate Contract PDF
export const CONTRACT_PDF_PATH = '/task/contract/pdf/:taskid/:taskrews_id';

// Cteate Contract PDF
export const FAQ_PATH = '/faq';
